import { ChainPath } from '@ankr.com/chains-list';

import { Tier, UUID, Web3Address } from '../common';

export interface IEnterpriseApiKey {
  address: Web3Address;
  name: string;
  token: string;
}

export interface IImportJWTTokenResult {
  address: Web3Address;
  id: UUID;
  roles: number[];
  tier: Tier;
  // use this token for private urls
  token: string;
  enterpriseApiKeys?: IEnterpriseApiKey[]; // DEPRECATED
  // if blockchains are presented it means user has a partner account type
  partnerChains?: ChainPath[];
}

export interface IPrivateEndpoint {
  blockchain: string;
  id?: string;
  requestUrl: string;
  scheme: string;
}

export type IProvider =
  | {
      address: string;
      blockchains: string[];
      id: string;
      limit: number;
    }
  | string;

export interface IWorkerEndpoint {
  blockchain: string;
  scheme: string;
  requestUrl: string;
  id: string;
  owner: string;
  user: string;
}

export interface GetPremiumStatusRawResult {
  freemium: boolean;
  status: PremiumStatus;
  isEnterprise: boolean;
}

export interface GetPremiumStatusResult {
  isFreemium: GetPremiumStatusRawResult['freemium'];
  status: GetPremiumStatusRawResult['status'];
  isEnterprise: GetPremiumStatusRawResult['isEnterprise'];
}

export enum PremiumStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export type RestrictedDomains = string[];

export type RestrictedIps = string[];

// The caller's allowed/denied RPC method patterns (across all blockchains).
// Empty lists mean no restriction. Entries are method names or wildcard
// patterns (e.g. "eth_*").
export interface MethodsConfig {
  allowedMethods: string[];
  deniedMethods: string[];
}

export interface RateLimitPerBlockchain {
  maxCallsPer10s: number;
  maxCallsPer10m: number;
}

// The caller's rate-limit caps. Zero means no limit. Blockchains listed in
// `perBlockchain` get their own separate caps; `maxCallsPerBlockchainCount`
// controls the rest (false = one total shared, true = each gets the full cap).
export interface RateLimitConfig {
  maxCallsPer10s: number;
  maxCallsPer10m: number;
  maxCallsPerBlockchainCount: boolean;
  perBlockchain: Record<string, RateLimitPerBlockchain>;
}
